module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Regular.25e2a56e.eot";